import { Component, AfterViewInit, ViewChild, ElementRef, OnInit, Input, ViewContainerRef, Injector } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { AgGridComponent, ColumnsToHide } from '../../ag-grid.component';

interface CustomCellRendererParams extends ICellRendererParams {
  onload?: (param1) => void
  subTableEdited?: (param1, param2) => void
  changeFieldControl: Subject<ColDef>,
  columnsChanged: () => ColumnsToHide[]
}

@Component({
  selector: 'app-ag-detail-panel',
  templateUrl: './sub-table.component.html',
  styleUrls: ['./sub-table.component.scss'],
})
export class SubtableComponent implements ICellRendererAngularComp, AfterViewInit, OnInit {
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;

  @Input() subTableParams!: CustomCellRendererParams
  renderCustomComponent = false

  
  selectedRadio = ''
  columDef
  gridOptions
  heightSubTable = ''
  showSubTable = true
  showRadioValueCustom = false
  @ViewChild('subTable') subTable!: AgGridComponent;
  @ViewChild('panel') panel!: ElementRef;

  

  public data: any;
  params!: CustomCellRendererParams;
  showDetailJsons: any;

    constructor(private injector: Injector) {}



  ngOnInit(): void {
    this.showDetailJsons = this.subTableParams.data?.showDetailJsons
    this.params = this.subTableParams;
    this.selectedRadio = this.params.data?.radioRenderSubTableConfig[0]
    this.setRowHeight()
  }
  

  agInit(params: any): void {

  }

   renderGenericComponent() {
    this.container.clear();

    const factory = this.container.createComponent(
      this.params.context.customSubComponent.component,
      { injector: this.injector }
    );

    if (factory.instance) {
      (factory.instance as any).data =  this.params.data.dataRow
      
    }
  }


  setRowHeight(){
    if(!!this.params.data.rowData && this.params?.data?.rowData.length === 0){
      this.heightSubTable = '300px'
      return;
    }
    const manyRows = !!this.params.data.subTotalPosition ? this.params?.data?.rowData.length + 1 : this.params?.data?.rowData.length 
    //height dinamico
    const headerHeight = document.querySelector('.ag-header')?.clientHeight || 48;
    const rowEl = document.querySelector('.ag-center-cols-container .ag-row');
    const rowHeight = rowEl?.getBoundingClientRect().height || 32;
    const maxHeight = ((11 * rowHeight) + headerHeight + 8 ) ;
    const dynamicHeight = ((manyRows * rowHeight) + headerHeight + 7);
    this.heightSubTable =  (dynamicHeight >= maxHeight ? maxHeight : dynamicHeight + 1) + 'px';
  }


  handleOnLoad() {
    const onload = this.params?.context?.onload || this.params?.onload;

    if (onload && typeof onload === 'function') {
      onload(this.panel.nativeElement, this.params.node);
    }
  }

  onRadioChange(selectedValue: any) {
    
    this.showSubTable = !this.showSubTable
    setTimeout(() => {
      this.handleOnLoad()

    })

  }

  ngAfterViewInit(): void {
    this.handleOnLoad()

    const changeFieldControl = this.params?.context?.changeFieldControl || this.params?.changeFieldControl;
    if (changeFieldControl) {
      changeFieldControl.subscribe((res) => {
        this.subTable.gridOptions.context = {
          ...(this.subTable.gridOptions.context || {}),
          dynamicField: res.field,
          
        };

        const column = this.subTable.gridOptions.columnApi?.getColumn(res.colId);
        if(column) {
          const colDef = column?.getColDef();
          colDef.field = res?.field;
          this.subTable.grid?.api.refreshCells({
            columns: [res?.colId],
            force: true
          });
          this.subTable.grid.api?.redrawRows()
        }
      });
    }

    if(this.params.columnsChanged() && this.subTable){
      this.columnsVisibilityControl(this.params.columnsChanged())
    }
    if(this.params.context.customSubComponent && this.params.context.customSubComponent.component){
      this.renderCustomComponent = true;
      this.renderGenericComponent()
    }
  }


  columnsVisibilityControl(cols: ColumnsToHide[]){
    cols.forEach(item => this.subTable.grid.columnApi.setColumnVisible(item.column, item.show))
  }

  getRowStyle = (params): any => {
    if (params.data && params.data.error) {
      return { backgroundColor: '#fff', border: '1px solid red' };
    }
    return undefined;
  }

  refresh(): boolean {
    return false;
  }

  bindCellEdit(event) {
    const subTableEdited = this.params?.context?.subTableEdited || this.params?.subTableEdited;
    if (subTableEdited && typeof subTableEdited === 'function') {
      subTableEdited(event, this.params.data.parentId);
    }
  }


  copyText(event){
    const copyText = document.getElementById("body");
    navigator.clipboard.writeText(copyText.textContent)
  }


  copyTextFormated(event) {
    if (!this.params?.data) return;

    const apenasEm1Array = this.params.data.dataRow.apenasEm1 || [];
    const apenasEm2Array = this.params.data.dataRow.apenasEm2 || [];
    const arquivosArray = this.params.data.dataRow.arquivos || [];

    const apenasEm1Text = apenasEm1Array.length > 0
      ? 'Só aparece na branch 1:\n' + apenasEm1Array.join('\n')
      : '';

    const apenasEm2Text = apenasEm2Array.length > 0
      ? 'Só aparece na branch 2:\n' + apenasEm2Array.join('\n')
      : '';

    const arquivosText = arquivosArray.length > 0
      ? 'JSONs:\n' + arquivosArray.join('\n')
      : '';

    const textToCopy = [apenasEm1Text, apenasEm2Text, arquivosText].filter(Boolean).join('\n\n');

    navigator.clipboard.writeText(textToCopy)
  }

}
